import createClient from '../../apolloClient';
import MUTATION_RESET_PASSWORD from '../../mutation/resetPassword';

const handleResetPassword = async (variables) => {
  const client = createClient();
  const result = await client.mutate({
    mutation: MUTATION_RESET_PASSWORD,
    variables,
  });
  const { resetPassword } = result?.data || {};
  return resetPassword;
};

export default handleResetPassword;
